import md5 from '../../modules/md5';
import Preloader from '../../modules/preloader';

export default class SubscribeIndex {
    constructor() {
        this.mainContainer = $('.js-index-subscribe-form');
        this.token = md5([...this.mainContainer.find('.js-token').val()].reverse().join(''));
        this.preloader = new Preloader();

        console.log(this.token);
    }

    init() {
        let _self = this;

        $(document).on('click', '.js-index-subscribe-form .js-submit', function() {


            let mail = _self.getEmail();

            if (mail.length === 0) {
                return;
            }

            const data = {
                token: _self.token,
                email: mail
            };

            _self.preloader.show();
            _self.hideErrorBox();

            $.ajax({
                url: '/ajax/action/index_block_subscribe_form/exec/',
                type: 'POST',
                data: data,
                success: function(result) {
                    _self.preloader.hide();
                    if (result.code === 400) {
                        _self.showErrorBox(result['data']['error']);
                        return false;
                    }
                    _self.showResult(result['data']['message']);
                }
            });
        });
    }

    getEmail() {
        return $.trim(this.mainContainer.find('.js-email').val());
    }

    showErrorBox(error) {
        this.mainContainer
            .find('.js-error-box')
            .show()
            .text(error);
    }

    hideErrorBox() {
        this.mainContainer
            .find('.js-error-box')
            .hide()
            .empty();
    }

    showResult(message) {
        let _self = this;

        this.mainContainer
            .find('.js-result-box')
            .show()
            .text(message);

        this.mainContainer.find('.js-email').val('');

        setTimeout(function() {
            _self.mainContainer.find('.js-result-box').fadeToggle();
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./blocks/index-block-subscribe-form/index-subscribe.js